(function (Drupal, once) {
  Drupal.behaviors.modernSelect = {
    attach: function (context, settings) {
      once('modernSelect', '.js-form-type-select').forEach((selectFormElement, index) => {
        const boxIndex = index + 1;

        const selectHTMLElement = selectFormElement.querySelector("select"),
          allSelectOptions = selectHTMLElement.querySelectorAll("option");

        const selectBox = document.createElement('div');
        selectBox.classList.add('select-box', 'box-' + boxIndex);
        selectBox.setAttribute('key', boxIndex);

        const selectBoxCurrent = document.createElement('div');
        selectBoxCurrent.classList.add('select-selected');

        const selectedOption = selectHTMLElement.selectedOptions[0];

        /**
         * If there is a default value, use it
         * Otherwise try using the select list's label
         * Last case scenario: use the first option of the list
         */
        if (selectedOption) {
          selectBoxCurrent.textContent = selectedOption.textContent;
        } else {
          selectBoxCurrent.textContent = selectHTMLElement.querySelector("option").textContent;
        }

        selectBox.appendChild(selectBoxCurrent);
        selectFormElement.appendChild(selectBox);

        const selectBoxItems = document.createElement('div');
        selectBoxItems.classList.add('select-items', 'select-hide');

        if (allSelectOptions.length >= 20) {
          const searchBar = document.createElement('header');
          searchBar.classList.add('select-top');

          const searchBarInput = document.createElement('input');
          searchBarInput.type = 'text';
          searchBarInput.id = 'select-keybind';
          searchBarInput.value = '';
          searchBarInput.placeholder = 'text';
          searchBarInput.size = '60';
          searchBarInput.maxLength = '255';
          searchBarInput.autocomplete = 'off';

          selectBoxItems.appendChild(searchBar);
          searchBar.appendChild(searchBarInput);
        }

        allSelectOptions.forEach((oneOption, optionIndex) => {
          const selectBoxItem = document.createElement('div');
          selectBoxItem.classList.add('list-item');
          selectBoxItem.setAttribute('value', oneOption.attributes.value.value);
          selectBoxItem.textContent = oneOption.textContent;

          selectBoxItem.addEventListener('click', (e) => {
            if (selectHTMLElement.selectedIndex !== optionIndex) {
              selectHTMLElement.options[selectHTMLElement.selectedIndex].selected = false;
              selectHTMLElement.options[optionIndex].selected = true;
              selectBoxCurrent.textContent = oneOption.textContent;
              selectHTMLElement.dispatchEvent(new Event('change'));
            }
          });

          selectBoxItems.appendChild(selectBoxItem);
        });

        selectBox.appendChild(selectBoxItems);

        document.addEventListener('click', (e) => {
          if (
            e.target != selectBoxCurrent &&
            e.target != selectBoxItems.querySelector("#select-keybind")
          ) {
            selectBoxItems.classList.add('select-hide');
            selectBoxCurrent.classList.remove('select-arrow-active');
          } else {
            selectBoxItems.classList.remove('select-hide');
            selectBoxCurrent.classList.add('select-arrow-active');
          }
        });
      });
    }
  };
})(Drupal, once);


/* (function (Drupal) {
  Drupal.behaviors.niceSelect = {
    attach: function (shsWidgetCreate, context, settings) {
      if (!settings) settings = Drupal.settings;

      window.addEventListener("load", function () {
        let alcatraz_sidebar_input = 0;

        if (document.querySelectorAll(".change-parent").length) {
        } else {
          document.querySelectorAll(".select-box").forEach(function (element) {
            element.remove();
          });
        }

        special_select();
        if (
          document.querySelector("body.page-node-add") ||
          document.querySelector("body.page-node-edit")
        ) {
          document
            .querySelectorAll(".form-item select")
            .forEach(function (select) {
              select.addEventListener("change", function () {
                document
                  .querySelector("select")
                  .parentElement.classList.remove("change-parent");
                this.parentElement.classList.add("change-parent");

                if (
                  !this.closest(".form-type-date-select") ||
                  this.closest(".form-type-date-select").length === 0
                ) {
                  special_select();
                }
              });
            });
        }

        document.addEventListener("click", function (event) {
          if (
            !event.target.closest(".select-box") &&
            event.target.querySelectorAll("input").length
          ) {
            document
              .querySelector(".select-box .select-selected")
              .classList.remove("select-arrow-active");
            document
              .querySelector(".select-box .select-items")
              .classList.add("select-hide");
          }
        });
      });

      document.addEventListener("ajaxComplete", function () {
        if (document.querySelectorAll(".change-parent").length) {
        } else {
          document.querySelectorAll(".select-box").forEach(function (element) {
            element.remove();
          });
        }

        special_select();
        if (
          document.querySelector("body.page-node-add") ||
          document.querySelector("body.page-node-edit")
        ) {
          document
            .querySelectorAll(".form-item.js-form-type-select select")
            .forEach(function (select) {
              select.addEventListener("change", function () {
                document
                  .querySelector("select")
                  .parentElement.classList.remove("change-parent");
                this.parentElement.classList.add("change-parent");

                special_select();
              });
            });
        }
      });

      window.special_select = function () {
        let Stext, St, Sfound, Onefoundhtml, opcio;

        let select_name;

        if (document.querySelectorAll(".change-parent").length) {
          document
            .querySelectorAll(
              "body .form-item.js-form-type-select.change-parent .select-box"
            )
            .forEach(function (selectBox) {
              selectBox.remove();
            });

          let i = 0;
          let j = 0;
          let select_find = 0;
          let width_calc = 0;

          document
            .querySelectorAll(
              "body .form-item.js-form-type-select.change-parent select"
            )
            .forEach(function (select) {
              if (
                select.closest(".field-type-entityreference") ||
                select.closest(".views-widget")
              ) {
                select_find = ".shs-select";
              } else {
                select_find = ".form-select";
              }

              i++;
              if (select.matches(select_find)) {
                j++;

                if (!select.parentElement.querySelector(".select-box")) {
                  select.parentElement.insertAdjacentHTML(
                    "beforeend",
                    `<div class="select-box box-${i}" key="${i}"><div class="select-selected">${
                      select.querySelector("option:first-child").innerHTML
                    }</div></div>`
                  );

                  select.parentElement
                    .querySelector(`.box-${i}`)
                    .insertAdjacentHTML(
                      "beforeend",
                      '<div class="select-items select-hide"></div>'
                    );

                  Array.from(select.querySelectorAll("option")).forEach(
                    function (option) {
                      if (option.innerHTML.length > width_calc) {
                        width_calc = option.innerHTML.length;
                      }

                      select.parentElement
                        .querySelector(`.box-${i} .select-items`)
                        .insertAdjacentHTML(
                          "beforeend",
                          `<div value="${option.value}">${option.innerHTML}</div>`
                        );

                      if (option.selected) {
                        select.parentElement.querySelector(
                          `.box-${i} .select-selected`
                        ).innerHTML = option.innerHTML;
                      }
                    }
                  );

                  select.parentElement.querySelector(
                    `.box-${i}`
                  ).style.minWidth = width_calc * 9 + 50 + "px";
                }
              }
            });
        } else {
          document
            .querySelectorAll(".form-item.js-form-type-select")
            .forEach(function (formItem) {
              let i = 0;
              let j = 0;
              let select_find;
              let width_calc = 0;

              if (
                formItem.closest(".field-type-entityreference") ||
                formItem.matches(".shs-wrapper-processed")
              ) {
                select_find = ".shs-select";
              } else {
                select_find = ".form-select";
              }

              Array.from(formItem.querySelectorAll("select")).forEach(function (
                select
              ) {
                i++;

                if (select.getAttribute("name") !== undefined) {
                  select_name = select.getAttribute("name");
                }

                if (select.matches(select_find)) {
                  j++;

                  if (!select.parentElement.querySelector(".select-box")) {
                    select.parentElement.insertAdjacentHTML(
                      "beforeend",
                      `<div class="select-box box-${i}" key="${i}"><div class="select-selected">${
                        select.querySelector("option:first-child").innerHTML
                      }</div></div>`
                    );

                    select.parentElement
                      .querySelector(`.box-${i}`)
                      .insertAdjacentHTML(
                        "beforeend",
                        '<div class="select-items select-hide"></div>'
                      );

                    let o = 0;

                    Array.from(select.querySelectorAll("option")).forEach(
                      function (option) {
                        o++;

                        if (option.innerHTML.length > width_calc) {
                          width_calc = option.innerHTML.length;
                        }

                        if (option.selected) {
                          select.parentElement.querySelector(
                            `.box-${i} .select-selected`
                          ).innerHTML = option.innerHTML;
                        }

                        select.parentElement
                          .querySelector(`.box-${i} .select-items`)
                          .insertAdjacentHTML(
                            "beforeend",
                            `<div value="${option.value}">${option.innerHTML}</div>`
                          );
                      }
                    );

                    if (o >= 20) {
                      select.parentElement
                        .querySelector(`.box-${i} .select-items`)
                        .insertAdjacentHTML(
                          "afterbegin",
                          '<header class="select-top"><a class="go-search">Search</a><input type="text" id="select-keybind" value="" placeholder="text" size="60" maxlength="255"></header>'
                        );
                    }

                    select.parentElement.querySelector(
                      `.box-${i}`
                    ).style.minWidth = width_calc * 9 + 50 + "px";
                  }
                }
              });
            });
        }

        Array.from(
          document.querySelectorAll(".select-box .select-items .go-search")
        ).forEach(function (goSearch) {
          goSearch.addEventListener("click", function () {
            goSearch.parentElement.querySelector("input").change();
          });
        });

        Array.from(
          document.querySelectorAll(".select-box .select-items #select-keybind")
        ).forEach(function (keybind) {
          keybind.addEventListener("change", function () {
            Stext = keybind.value;
            St = 0;
            Sfound = 0;
            Onefoundhtml = 0;

            Array.from(keybind.parentElement.querySelectorAll("div")).forEach(
              function (div) {
                if (
                  div.textContent.toLowerCase().substr(0, Stext.length) ===
                  Stext.toLowerCase()
                ) {
                  if (div.textContent.toLowerCase() === Stext.toLowerCase()) {
                    div.parentElement
                      .closest(".select-box")
                      .querySelector(".select-selected")
                      .classList.remove("select-arrow-active");
                    div.parentElement
                      .closest(".select-box")
                      .querySelector(".select-items")
                      .classList.add("select-hide");
                    div.parentElement
                      .closest(".select-box")
                      .querySelector(".select-selected").innerHTML =
                      div.innerHTML;

                    opcio = div.innerHTML;

                    Array.from(
                      div.parentElement
                        .closest(".form-item.js-form-type-select")
                        .querySelectorAll("select option")
                    ).forEach(function (option) {
                      if (option.innerHTML === opcio) {
                        option.setAttribute("selected", "selected");
                        option.change();
                      } else {
                        option.removeAttribute("selected");
                      }
                    });

                    return false;
                  } else {
                    Sfound++;
                    if (Sfound === 1) {
                      Onefoundhtml = div.innerHTML;
                    } else {
                      Onefoundhtml = 0;
                    }
                  }
                } else {
                  if (Sfound === 0) {
                    St++;
                  }
                }
              }
            );

            if (Sfound === 1) {
              keybind.parentElement
                .closest(".select-box")
                .querySelector(".select-selected")
                .classList.remove("select-arrow-active");
              keybind.parentElement
                .closest(".select-box")
                .querySelector(".select-items")
                .classList.add("select-hide");
              keybind.parentElement
                .closest(".select-box")
                .querySelector(".select-selected").innerHTML = Onefoundhtml;

              opcio = Onefoundhtml;

              Array.from(
                keybind.parentElement
                  .closest(".form-item.js-form-type-select")
                  .querySelectorAll("select option")
              ).forEach(function (option) {
                if (option.innerHTML === opcio) {
                  option.setAttribute("selected", "selected");
                  option.change();
                } else {
                  option.removeAttribute("selected");
                }
              });
            } else {
              keybind.parentElement.querySelector(".select-items").scrollTop =
                St * 32;
            }
          });
        });

        Array.from(
          document.querySelectorAll(".select-box .select-selected")
        ).forEach(function (selectSelected) {
          selectSelected.addEventListener("click", function () {
            if (selectSelected.classList.contains("select-arrow-active")) {
              selectSelected.classList.remove("select-arrow-active");
              selectSelected.parentElement
                .querySelector(".select-items")
                .classList.add("select-hide");
            } else {
              Array.from(
                document.querySelectorAll(".select-box .select-selected")
              ).forEach(function (item) {
                item.classList.remove("select-arrow-active");
              });

              Array.from(
                document.querySelectorAll(".select-box .select-items")
              ).forEach(function (item) {
                item.classList.add("select-hide");
              });

              selectSelected.classList.add("select-arrow-active");

              selectSelected.parentElement
                .querySelector(".select-items")
                .classList.remove("select-hide");

              if (
                selectSelected.parentElement.querySelector("#select-keybind")
              ) {
                selectSelected.parentElement
                  .querySelector("#select-keybind")
                  .focus();
              }

              selectSelected.parentElement.querySelector(
                ".select-items"
              ).scrollTop = 0;
            }
          });
        });

        Array.from(
          document.querySelectorAll(".select-box .select-items > div")
        ).forEach(function (div) {
          div.addEventListener("click", function () {
            Sfound = 0;
            div.parentElement
              .closest(".select-box")
              .querySelector(".select-selected").innerHTML = div.innerHTML;
            div.parentElement.querySelectorAll("div").forEach(function (item) {
              item.classList.remove("active");
            });
            div.classList.add("active");

            div.parentElement
              .closest(".select-box")
              .querySelector(".select-selected")
              .classList.remove("select-arrow-active");
            div.parentElement
              .closest(".select-box")
              .querySelector(".select-items")
              .classList.add("select-hide");

            opcio = div.innerHTML;

            var extraszam = 0;
            if (
              document.querySelector("body.page-node-add") ||
              document.querySelector("body.page-node-edit")
            ) {
              extraszam = div.parentElement
                .closest(".select-box")
                .getAttribute("key");
              extraszam++;

              if (
                div.parentElement.closest(".form-type-date-select") &&
                div.parentElement.closest(".form-type-date-select").length !== 0
              ) {
                extraszam = 1;
              }
            } else {
              extraszam = div.parentElement
                .closest(".select-box")
                .getAttribute("key");
            }

            Array.from(
              div.parentElement
                .closest(".form-item.js-form-type-select")
                .querySelectorAll("select option")
            ).forEach(function (option) {
              if (option.innerHTML === opcio) {
                option.setAttribute("selected", "selected");
                option.change();
              } else {
                option.removeAttribute("selected");
              }
            });
          });
        });
      };
    },
  };
})(Drupal);
 */
